// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";

function getVm(order) {
  return List.map((function (w) {
                return {
                        landmark: w.place.landmark,
                        contact_name: w.contact.name,
                        contact_number: w.contact.number
                      };
              }), order._0.waypoints);
}

export {
  getVm ,
  
}
/* No side effect */
